import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  performanceCurrentFrontlineVolumeById,
  performanceCurrentGen0VolumeById,
  performanceDeltaFrontlineVolumeById,
  performanceDeltaGen0VolumeById,
  performanceSameDayLastMonthFrontlineVolumeById,
  performanceSameDayLastMonthGen0VolumeById,
  sameDayLastMonth,
} from '/redux/selector/coach.selector';

import OrderMetrics from './OrderMetrics';

export default connect(
  createStructuredSelector({
    currentFrontlineVolume: performanceCurrentFrontlineVolumeById,
    lastMonthFrontlineVolume: performanceSameDayLastMonthFrontlineVolumeById,
    deltaFrontlineVolume: performanceDeltaFrontlineVolumeById,
    currentGen0Volume: performanceCurrentGen0VolumeById,
    lastMonthGen0Volume: performanceSameDayLastMonthGen0VolumeById,
    deltaGen0Volume: performanceDeltaGen0VolumeById,
    sameDayLastMonth: sameDayLastMonth,
  }),
)(OrderMetrics);
